import React, { FC, useCallback, useState } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { productionBatchStatistics } from '@reducers/statistics';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { getNCFileById } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { setParts, setPartId, updateHeaderConfig } from '@reducers/details';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';
import { useFocusEffect } from '@react-navigation/native';
import { getPartByID, getPartsByID } from '@reducers/parts';
import { PartListOrSingleItem } from '@v2/pages/machines/modules/now/components/Part/components/PartListOrSingleItem';

interface BatchDetailsPartProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
  partId: number | null;
}

const BatchDetailsPartComponent: FC<BatchDetailsPartProps> = ({
  clearTools,
  getNCFileById,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
  getPartsByID,
  getPartByID,
  setParts,
  setPartId,
  batch,
  partId,
}) => {
  const title = useTitle();
  const [partDataLoading, setPartDataLoading] = useState<boolean>(true);

  const { partDataLoading: partDataLoadingForNotLinkedBatch } = useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
    getPartByID,
  });

  const links = batch.data?.links;

  useFocusEffect(
    useCallback(() => {
      if (links?.length === 0) {
        return;
      }

      const loadAndSetParts = async () => {
        const partIds = [...new Set(batch?.data?.links.map((l) => l.partId))];
        if (!partIds.length || !getPartsByID) return;
        const partsData = await getPartsByID({ ids: partIds });
        if (partsData.searchResult) {
          setParts(partsData.searchResult);
          if (partsData.searchResult?.length === 1) {
            setPartId(partsData.searchResult?.[0]?.partId);
          }
        }
        setPartDataLoading(false);
      };

      loadAndSetParts();
    }, [batch?.data?.productionBatchId, !!links?.length])
  );

  return (
    <DetailsPageWrapper title={title.part}>
      <PartListOrSingleItem partDataLoadingForList={links?.length === 0 ? partDataLoadingForNotLinkedBatch : partDataLoading} partId={partId} />
    </DetailsPageWrapper>
  );
};

const BatchDetailsPart = connect(({ details: { partId }, batch: { batch } }) => ({ batch, partId }), {
  clearTools,
  getNCFileById,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
  getPartsByID,
  getPartByID,
  setParts,
  setPartId,
})(BatchDetailsPartComponent);

export { BatchDetailsPart };
